import React from 'react';
import { ClockIcon, SearchIcon, MessageSquareIcon } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    icon: ClockIcon,
    medal: '🥇',
    title: 'Plantillas de Sesiones Listas para Usar (30, 60 y 90 min)',
    description: 'Estructuras exactas minuto a minuto con zonas a trabajar según objetivo. Aplicalo hoy mismo.'
  }, {
    icon: SearchIcon,
    medal: '🥈',
    title: 'Guía de Evaluación Express en 5 Minutos',
    description: 'Checklist de evaluación postural para detectar la causa real del dolor desde la primera sesión.'
  }, {
    icon: MessageSquareIcon,
    medal: '🥉',
    title: 'Scripts para Explicar el Tratamiento y Cerrar Clientes',
    description: 'Qué decirle al cliente, cómo explicar el dolor y cómo recomendar más sesiones para aumentar tus ingresos.'
  }];
  return <section className="w-full px-4 py-10 md:py-16 bg-[#050810]" data-id="element-9">
      <div className="max-w-3xl mx-auto" data-id="element-10">
        <h2 className="text-2xl md:text-3xl font-bold text-[#D4A843] mb-3 text-center" data-id="element-11">
          BONOS EXCLUSIVOS
        </h2>

        <div className="text-center mb-8" data-id="element-12">
          <span className="inline-block bg-[#D4A843] text-[#0a0f1a] font-bold text-sm md:text-base px-5 py-2 rounded-lg" data-id="element-13">
            🎁 GRATIS POR EL DÍA DE HOY
          </span>
        </div>

        <div className="space-y-4" data-id="element-14">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <div key={index} className="bg-[#0a0f1a] border border-[#D4A843]/50 p-4 md:p-5 rounded-lg" data-id="element-15">
                <div className="flex items-start gap-3" data-id="element-16">
                  <div className="bg-[#D4A843] p-2 rounded-lg flex-shrink-0" data-id="element-17">
                    <Icon className="w-5 h-5 text-[#0a0f1a]" data-id="element-18" />
                  </div>
                  <div className="flex-1" data-id="element-19">
                    <h3 className="text-base md:text-lg font-bold text-white mb-1" data-id="element-20">
                      {bonus.medal} BONO {index + 1}: {bonus.title}
                    </h3>
                    <p className="text-sm md:text-base text-gray-400" data-id="element-21">
                      {bonus.description}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}